import { Flex, Text, useDisclosure } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { Button, Chip, Column, Icon, Row } from '@ubirider/pick-component-library'
import React from 'react'
import { BalsasStops } from '../../../../consts/stops'
import { DateTime } from 'luxon'
import { motion } from 'motion/react'

import ArrowIcon from '../../../../assets/arrow_right.svg'
import BoatIcon from '../../../../assets/boat.svg'
import QRCodeIcon from '../../../../assets/qrcode.svg'
import { QRCodeModal } from './components/QRCodeModal'
import { userTimezone } from '../../../../App'

const MFlex = motion.create(Flex)

export const Ticket = ({ ticket }) => {
  const { t } = useTranslation()

  const ticketDateTime = DateTime.fromSeconds(ticket.validFrom).setZone(userTimezone).plus({ hour: 1 })
  const ticketDate = ticketDateTime.toFormat('dd/MM/yyyy')
  const ticketTime = ticketDateTime.toFormat('HH:mm')

  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <MFlex
      bg='white'
      rounded='24px'
      css={'box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1)'}
      border='1px solid #EAECF0'
      paddingInline='24px'
      paddingBlock='24px'
      direction='column'
      gap='8px'
      whileHover={{ y: -4, boxShadow: '0px 12px 20px -5px rgba(0, 0, 0, 0.1)' }}
      transition={{ type: 'spring', stiffness: 400, damping: 30 }}
    >
      <Flex direction={{ sm: 'column', lg: 'row' }} flex={1} gap='32px' alignItems={{ lg: 'center' }}>
        <Column css={{ flex: 1, gap: 16 }}>
          <Row css={{ gap: 12 }}>
            <Flex bg='#F9FAFB' rounded='14px' w='48px' h='48px' align='center' justify='center'>
              <Icon src={BoatIcon} />
            </Flex>
            <Column>
              <Text fontSize='14px' color='#98A2B3'>
                Bilhete Hora Marcada
              </Text>
              <Row css={{ gap: 4, alignItems: 'center' }}>
                <Text fontSize='18px' fontWeight='700'>
                  {BalsasStops[ticket.agencyID][ticket.originID]}
                </Text>
                <Icon src={ArrowIcon} css={{ ml: 8, mt: 8 }} />
                <Text fontSize='18px' fontWeight='700'>
                  {BalsasStops[ticket.agencyID][ticket.destinationID]}
                </Text>
              </Row>
            </Column>
          </Row>
          <Flex display={{ sm: 'flex', lg: 'none' }}>
            <Chip label={ticket.licensePlate} />
          </Flex>
          <Row css={{ gap: 16, flex: 1, alignItems: 'center' }}>
            <Flex flex='2' display={{ sm: 'none', lg: 'flex' }}>
              <Chip label={ticket.licensePlate} />
            </Flex>
            <Column css={{ flex: 2 }}>
              <Text fontSize='12px' fontWeight='700' color='#98A2B3' textTransform='uppercase'>
                Data
              </Text>
              <Text fontSize='12px' fontWeight='700'>
                {ticketDate}
              </Text>
            </Column>
            <Column css={{ flex: 2 }}>
              <Text fontSize='12px' fontWeight='700' color='#98A2B3' textTransform='uppercase'>
                Hora
              </Text>
              <Text fontSize='12px' fontWeight='700'>
                {ticketTime}
              </Text>
            </Column>
            <Flex direction='column' display={{ sm: 'none', lg: 'flex' }} flex={2}>
              <Text fontSize='12px' fontWeight='700' color='#98A2B3' textTransform='uppercase'>
                ID FATURA
              </Text>
              <Text fontSize='12px' fontWeight='700'>
                {ticket?.invoiceID}
              </Text>
            </Flex>
          </Row>
          <Flex direction='column' display={{ sm: 'flex', lg: 'none' }}>
            <Text fontSize='12px' fontWeight='700' color='#98A2B3' textTransform='uppercase'>
              ID FATURA
            </Text>
            <Text fontSize='12px' fontWeight='700'>
              {ticket?.invoiceID}
            </Text>
          </Flex>
        </Column>

        <Button
          onClick={onOpen}
          type='neutralDark'
          style='solid'
          size='small'
          disabled={!ticket?.qrCode}
          label={t('acqua_vias.your_tickets_view_ticket')}
          leftIconProps={{ src: QRCodeIcon }}
        />
      </Flex>

      <QRCodeModal qrCode={ticket?.qrCode} onOpen={onOpen} onClose={onClose} isOpen={isOpen} />
    </MFlex>
  )
}